import { useMemo, useCallback, useState } from 'react'
import isEmpty from 'lodash/isEmpty'
import { useSelector } from 'react-redux'
import { selectIsReadyToShowSplashAd, selectIsViewedAdvertisement, selectCurrentSplashAd } from 'redux/selector/app'
import { fetchPostAdEvent } from 'api'
import { TRUE } from 'constant/common'
import Timer from './component/Timer'
import { Wrapper, Item, LateLoadingContainer } from './Styled'
import SplashInviteCode from 'component/SplashInviteCode'
import { patchUrlProtocol } from 'utils/urlUtils'
import { formatDate } from 'utils/timeFormat'
import SplashVersionNumber from 'component/SplashVersionNumber'
import { EncryptedImg } from 'component/EncryptedElements'
import themeAssetloadingLongLoadingEncGif from '@theme/loading/long-loading.enc.gif'
import StartupConnectionReminderInlineTrigger from 'component/StartupConnectionReminder/InlineTrigger'
import StartupConnectionReminder from 'component/StartupConnectionReminder'
import EntryDomainUpdateTooltip from 'component/EntryDomainUpdateTooltip'

/** App 入站廣告頁面 */
export default function LaunchScreenAd() {
  const isReadyToShowSplashAd = useSelector(selectIsReadyToShowSplashAd)
  const isViewedAdvertisement = useSelector(selectIsViewedAdvertisement)

  const { item: adEntrance, img: base64Img } = useSelector(selectCurrentSplashAd) ?? {}

  /** 從幾秒開始倒數 */
  const duration = adEntrance?.countdown
  /** 廣告結束後是否自動進入首頁 */
  const isAutoIntoLobby = adEntrance?.auto_close === TRUE

  const isShow = useMemo(() => {
    return isReadyToShowSplashAd && !isViewedAdvertisement && !isEmpty(adEntrance)
  }, [isReadyToShowSplashAd, isViewedAdvertisement, adEntrance])

  const handleOnClick = useCallback(() => {
    const link = patchUrlProtocol(adEntrance?.link)
    fetchPostAdEvent({
      date: formatDate(new Date()),
      material_id: adEntrance.id,
      material_name: adEntrance.name,
      oholo_site_id: adEntrance.site_type,
      oholoer_id: adEntrance.oholoer_id,
      oholoer_link: adEntrance.oholoer_link,
      oholoer_name: adEntrance.oholoer_name,
    })
    window.open(link, '_blank')
  }, [adEntrance])

  const [lateLoading, setLateLoading] = useState(false)
  const [connectionReminderOpen, setConnectionReminderOpen] = useState(false)

  return (
    <>
      {isShow && (
        <Wrapper>
          <Item base64Img={base64Img} onClick={handleOnClick} />
          <Timer duration={duration} isAutoIntoLobby={isAutoIntoLobby} onLateLoading={setLateLoading} />
          <SplashInviteCode />
          <SplashVersionNumber />
          {lateLoading && (
            <LateLoadingContainer>
              <EncryptedImg alt="" src={`${themeAssetloadingLongLoadingEncGif}`} />
              <div>全力冲刺中</div>
              <StartupConnectionReminderInlineTrigger
                active={lateLoading}
                onOpen={() => setConnectionReminderOpen(true)}
              />
            </LateLoadingContainer>
          )}
          <StartupConnectionReminder
            isOpen={connectionReminderOpen}
            onAction={() => setConnectionReminderOpen(false)}
          />
          <EntryDomainUpdateTooltip />
        </Wrapper>
      )}
    </>
  )
}
